module.exports = __webpack_public_path__ + "static/img/typeOne.e34b023e.png";